export function externalShipmentAffPrepareValidate(prepared){
    var result = true;
    var errors = [];

    result = validateTransactionId(prepared.transaction_id, errors);
    
    if(!result) return errors;
    else return result;
}

function validateTransactionId(transaction_id, errors){    
    if(Number.isInteger(transaction_id)) return true;
    else { 
        errors.push("transaction_id_not_valid");
        return false;
    }
}
